import React, { useState } from 'react'
import { Building2, Globe, HelpCircle } from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import HelpModal from '../../components/HelpModal/HelpModal'
import { useNavigate } from 'react-router-dom'

const OrganisationMaster = () => {
  const navigate = useNavigate()
  const [showHelp, setShowHelp] = useState(false)

  const breadcrumbItems = [
    { label: 'Settings', path: '/settings', onClick: () => navigate('/settings') },
    { label: 'Organisation', path: '/settings/organisation', isCurrent: true },
  ]

  const cards = [
    {
      key: 'company',
      title: 'Company',
      description: 'Legal entities, GSTIN, addresses and company profile',
      icon: Building2,
      path: '/settings/company-master',
    },
    {
      key: 'global',
      title: 'Global',
      description: 'Organisation-wide defaults, locales and shared settings',
      icon: Globe,
      path: '/settings/global-master',
    },
  ]

  return (
    <div className="sales-dashboard">
      <div className="breadcrumb-section">
        <Breadcrumb
          items={breadcrumbItems}
          rightSlot={
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
              onClick={() => setShowHelp(true)}
              title="Help"
              aria-label="Open help"
            >
              <HelpCircle size={18} />
              <span className="d-none d-sm-inline">Help</span>
            </button>
          }
        />
      </div>

      <div className="page-header">
        <div className="page-title">
          <h1>Organisation</h1>
          <p>Company profile and organisation-wide defaults</p>
        </div>
      </div>

      <div className="settings-masters-grid">
        {cards.map((card) => {
          const Icon = card.icon
          return (
            <div
              key={card.key}
              className="settings-master-card"
              onClick={() => navigate(card.path)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  navigate(card.path)
                }
              }}
            >
              <div className="settings-master-icon">
                <Icon size={24} />
              </div>
              <div className="settings-master-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          )
        })}
      </div>

      <HelpModal isOpen={showHelp} onClose={() => setShowHelp(false)} title="Organisation – Help">
        <h3>Organisation</h3>
        <p>Open <strong>Company</strong> for legal entity details, or <strong>Global</strong> for shared organisation defaults.</p>
      </HelpModal>
    </div>
  )
}

export default OrganisationMaster
